import {
  localStorageGet,
  localStorageSet,
} from '../../scripts/utils/localstorage';

export const initStickyBanner = () => {
  const stickyBannerEl = document.querySelector(
    '[data-email-subscribe-banner]'
  );

  if (!stickyBannerEl) {
    return;
  }

  const bannerName = stickyBannerEl.dataset.emailSubscribeBanner;

  toggleStickyBannerVisibility(stickyBannerEl, bannerName);
  addEventListeners(stickyBannerEl, bannerName);
};

function toggleStickyBannerVisibility(stickyBannerEl, bannerName) {
  const isShowStickyForm = stickyBannerEl.dataset.emailSubscribeShowSticky;
  const bodyClassList = document.body.classList;

  if (
    !isShowStickyForm ||
    localStorageGet(bannerName) ||
    bodyClassList.contains('template-name-product')
  ) {
    stickyBannerEl.setAttribute('data-email-subscribe-show-sticky', 'false');
  } else {
    stickyBannerEl.setAttribute('data-email-subscribe-show-sticky', 'true');
  }
}

function addEventListeners(stickyBannerEl, bannerName) {
  const closeBtn = stickyBannerEl.querySelector(
    '[data-email-subscribe-close-banner]'
  );

  if (closeBtn) {
    closeBtn.addEventListener('click', (event) => {
      event.stopPropagation();
      hideStickyBanner(stickyBannerEl, bannerName);
    });
  }

  // Klaviyo subscribe form submit event
  window.addEventListener('klaviyoForms', (event) => {
    if (event.detail.type === 'submit') {
      showSuccessMessage(stickyBannerEl, bannerName);

      const consentFormId = event.detail.metaData.$consent_form_id;

      if (window.GoogleAnalytics && window.GoogleAnalytics.trackEvent) {
        window.GoogleAnalytics.trackEvent(
          'Email Subscribe',
          'Form Submit',
          consentFormId
        );
      }
    }
  });
}

function showSuccessMessage(stickyBannerEl, bannerName) {
  stickyBannerEl.setAttribute('data-email-subscribe-success', 'true');
  localStorageSet(bannerName, true);
}

function hideStickyBanner(stickyBannerEl, bannerName) {
  stickyBannerEl.setAttribute('data-email-subscribe-show-sticky', 'false');
  localStorageSet(bannerName, true);
}
